import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import IconClose from 'components/icons/iconClose';
const MoveItButton = t0 => {
  const $ = _c(8);
  const {
    className: t1,
    icon: t2,
    isCloseButton: t3,
    onClick
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const Icon = t2 === undefined ? IconClose : t2;
  const isCloseButton = t3 === undefined ? true : t3;
  const t4 = isCloseButton ? "Close" : undefined;
  const t5 = `items-center bg-white border border-solid border-gray-light6 rounded-[48px] text-gray cursor-pointer flex h-12 justify-center w-12 z-[1] hover:border-brand [&_svg_path]:fill-gray ${className}`;
  const t6 = isCloseButton ? "Close" : undefined;
  let t7;
  if ($[0] !== Icon) {
    t7 = <Icon />;
    $[0] = Icon;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  let t8;
  if ($[2] !== onClick || $[3] !== t4 || $[4] !== t5 || $[5] !== t6 || $[6] !== t7) {
    t8 = <button aria-label={t4} className={t5} onClick={onClick} title={t6} type="button">{t7}</button>;
    $[2] = onClick;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  return t8;
};
MoveItButton.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.element,
  isCloseButton: PropTypes.bool,
  onClick: PropTypes.func
};
export default MoveItButton;